import DatabaseModel from './DatabaseModel.js';

var TipoItem = Object.create(DatabaseModel);

TipoItem.model = 'tipoitem';
TipoItem.modelFront = 'tipositem';

export default TipoItem;